import { table } from 'console';
import Card, { CardProps } from '.';
import CardProductList from './CardProductList';

export interface CardProductProps extends CardProps {
  title: string;
  price: number;
  code: number;
  ean: string;
  imageSrc: string;
  imageAlt: string;
}

export default Object.assign(
  function CardProduct({
    title,
    price,
    ean,
    code,
    imageSrc,
    imageAlt,
    children,
    className = '',
    ...rest
  }: CardProductProps) {
    return (
      <Card className={`card-product ${className}`} {...rest}>
        <Card.Header style={{}}>
          <Card.Label style={{ color: '#364856' }}>{ean}</Card.Label>
          <Card.Label style={{ color: '#364856' }}>{code}</Card.Label>
        </Card.Header>
        <Card.Body>
          <Card.Image src={imageSrc} alt={imageAlt} />
          <Card.Title
            style={{
              color: '#364856',
              marginBlockStart: '0em',
              marginBlockEnd: '0em',
            }}
          >
            {title}
          </Card.Title>
          <Card.Subtitle style={{ color: '#364856' }}>
            {`R$ ${(price / 100).toFixed(2)}`.replace('.', ',')}
          </Card.Subtitle>
          {children}
        </Card.Body>
      </Card>
    );
  },
  {
    List: CardProductList,
  },
);
